var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#EDF0F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6446 10.0429C18.0351 10.4334 18.0351 11.0666 17.6446 11.4571L12.6017 16.5H24.8125C25.3648 16.5 25.8125 16.9477 25.8125 17.5C25.8125 18.0523 25.3648 18.5 24.8125 18.5H12.6017L17.6446 23.5429C18.0351 23.9334 18.0351 24.5666 17.6446 24.9571C17.2541 25.3476 16.6209 25.3476 16.2304 24.9571L9.48039 18.2071C9.08987 17.8166 9.08987 17.1834 9.48039 16.7929L16.2304 10.0429C16.6209 9.65237 17.2541 9.65237 17.6446 10.0429Z",
    fill: "#B8C7D3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackCircle);
export default __webpack_public_path__ + "static/media/back-circle.669c3c185e4072ccdd265956edbe8dfa.svg";
export { ForwardRef as ReactComponent };